import React, { useState, useEffect } from "react";
import { Stack, FormControl, FormLabel, Switch, Flex, Badge } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditPackagePlanDrawer = ({ isOpen, onClose, plan, onUpdatePlan }) => {
  const [formData, setFormData] = useState({
    name: "",
    deliveries: 0,
    expiry_days: 90,
    description: "",
    is_active: true,
  });

  useEffect(() => {
    if (plan) {
      setFormData({
        name: plan.name || "",
        deliveries: plan.deliveries ?? 0,
        expiry_days: plan.expiry_days ?? 90,
        description: plan.description || "",
        is_active: plan.is_active ?? true,
      });
    }
  }, [plan]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleToggleActive = (e) => {
    setFormData((prev) => ({ ...prev, is_active: e.target.checked }));
  };

  const handleSubmit = () => {
    onUpdatePlan({ ...plan, ...formData });
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Edit Package Plan</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Plan name"
            isDisabled={true}
          />

          <ReusableInput
            label="Deliveries"
            name="deliveries"
            value={formData.deliveries}
            onChange={handleChange}
            placeholder="Deliveries"
            type="number"
          />

          <ReusableInput
            label="Expiry Days"
            name="expiry_days"
            value={formData.expiry_days}
            onChange={handleChange}
            placeholder="Expiry in days"
            type="number"
          />

          <ReusableInput
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Plan description"
            type="textarea"
          />

          <FormControl display="flex" alignItems="center" justifyContent="space-between">
            <Flex alignItems="center" gap={3}>
              <FormLabel mb="0">Enable or disable this plan</FormLabel>
              <Badge
                colorScheme={formData.is_active ? "green" : "red"}
                variant="subtle"
                px={4}
                py={2}
                borderRadius="full"
                fontSize="sm"
                fontWeight="semibold"
              >
                {formData.is_active ? "Active" : "Inactive"}
              </Badge>
            </Flex>

            <Switch
              isChecked={formData.is_active}
              onChange={handleToggleActive}
              size="md"
              sx={{
                "& .chakra-switch__track[data-checked]": {
                  backgroundColor: "#071D54",
                },
              }}
            />

          </FormControl>

        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} width="100px" height="40px">
            Cancel
          </GradientButton>
          <GradientButton onClick={handleSubmit} width="100px" height="40px">
            Update
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditPackagePlanDrawer;
